import { useQuery } from '@apollo/client';
import {PRODUCT} from "../productTypeDefs";

export const useQueryProduct = (options?: any): any => (
  useQuery(PRODUCT, options)
);
